import LayoutContainer from 'components/Common/LayoutContainer'
import LineAnalysisIcon from 'components/Luxkit/Icons/line/LineAnalysisIcon'
import BodyText from 'components/Luxkit/Typography/BodyText'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { CUSTOMER_TYPES, PEOPLE_LIKE_ME_BANNER_MINIMUM } from 'constants/search'
import { getSaleBannerText } from 'lib/customer/peopleLikeMeUtils'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

interface Props {
  customerType: CUSTOMER_TYPES,
  saleCount: number
}

const SalesBanner = styled(LayoutContainer)`
width: 100%;
background-color: ${props => props.theme.palette.messaging.fast.light};
color: ${props => props.theme.palette.messaging.fast.main};
padding: ${rem(8)};
padding-left:${rem(20)};
line-height: ${rem(12)};
align-items: center;
display: flex;
${mediaQueryUp.tablet} {
  padding-left: ${rem(28)};
}
`

const StyledBodyText = styled(BodyText)`
  padding-left: ${rem(4)};
`

function PeopleLikeMeSalesBanner(props: Props) {
  const {
    saleCount,
    customerType,
  } = props

  if (saleCount < PEOPLE_LIKE_ME_BANNER_MINIMUM) {
    return null
  }

  const saleBannerText = getSaleBannerText(customerType, saleCount)

  return (
    <SalesBanner>
      <LineAnalysisIcon />
      <StyledBodyText variant="small">Booked by&nbsp;</StyledBodyText><BodyText variant="small" weight="bold">{saleBannerText}</BodyText><BodyText variant="small">&nbsp;in the past month</BodyText>
    </SalesBanner>
  )
}

export default PeopleLikeMeSalesBanner
